<template>
  <templateAdminComponent v-if="isUserAuthenticated()">
    <!-- LAISSER ACTIVE, CECI FAIT EN SORTE DE COPIER L'IMAGE LORS D'UN RUN BUILD -->
    <img width="550" src="@/assets/img/logoentete.jpg">
  </templateAdminComponent>
</template>

<script>
import auth from '@/auth'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'

var axios = require('axios')

export default {
  components:
  {
    TemplateAdminComponent
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/_StaticIncludes.vue